/**
 * Import all module depenencies here.
 * Add commonly used modules to externals.
 */
import core from '../../../app.core.module.js';
import twofaConfirmationConfig from './2fa.confirmation.config.js';
import twofaConfirmationRoute from './2fa.confirmation.route.js';
import twofaConfirmationController from './2fa.confirmation.controller.js';

/**
 * This is the 2fa module. It it the entry point for this website.
 * Only declare the module's dependencies in this file.
 * @namespace 2fa Module
 */
angular.module('twofactorConfirmation', [
  // Shared modules.
  core
])
// Register config.
.config(twofaConfirmationConfig)
// Register route.
.config(twofaConfirmationRoute)
// Register controller.
.controller('twofaConfirmationController', twofaConfirmationController);



export default 'twofactorConfirmation';


// WEBPACK FOOTER //
// ./src/login/2fa/confirmation/2fa.confirmation.module.js